export type EvTechnicalTemplateLinePayload = {
  lineKey: string;
  label: string;
  quantity: number | null;
  unit: string | null;
  requirement: "required" | "conditional" | "optional";
  condition?: string;
  productId: number | null;
  estimatedUnitCost: number | null;
  costSource?: string;
  costDate?: string;
};

type EditableLine = EvTechnicalTemplateLinePayload & {
  estimatedUnitCost: number | null;
  costSource: string;
  costDate: string;
};

export function buildEvTechnicalTemplatePayload(lines: EditableLine[], canEditEconomics: boolean): EvTechnicalTemplateLinePayload[] {
  return lines.map(({ estimatedUnitCost, costSource, costDate, ...line }) => {
    const costHasProvenance = canEditEconomics && estimatedUnitCost !== null && Boolean(costSource.trim()) && Boolean(costDate);
    return {
      ...line,
      estimatedUnitCost: costHasProvenance ? estimatedUnitCost : null,
      ...(costHasProvenance ? { costSource, costDate } : {}),
    };
  });
}

export function expectedRevisionForEvTemplateSave(version: { status: string; revision?: number | null } | null | undefined): number {
  return version?.status === "draft" ? Number(version.revision ?? 0) : 0;
}

export function isSavedEvTemplateRevisionCurrent(saved: { versionNumber: number; revision: number }, current: { versionNumber: number; revision: number; status: string } | null | undefined): boolean {
  return current?.status === "draft"
    && Number(current.versionNumber) === Number(saved.versionNumber)
    && Number(current.revision) === Number(saved.revision);
}

export async function saveThenApproveEvTemplate<T extends { versionNumber: number; revision: number }, D extends { id: number; versionNumber: number; revision: number; status: string }>(
  persist: () => Promise<T>,
  readCurrent: () => Promise<D | null | undefined>,
  approve: (versionId: number) => Promise<unknown>,
): Promise<void> {
  const saved = await persist();
  const current = await readCurrent();
  if (!isSavedEvTemplateRevisionCurrent(saved, current)) throw new Error("El borrador guardado cambió; vuelve a cargarlo antes de aprobar.");
  await approve(Number(current!.id));
}
